<td-wb-sticky-observer [offset]="offset" />
<div class="td-wb-sticky-panel__offset"></div>
<ng-content />
